import React, { Component } from "react";
import ActionButton from "./actionButton";
import TitleBar from "../titleBar/title_bar";
import { AgGridReact } from "ag-grid-react";
import { AllModules } from "ag-grid-enterprise";
import { Header, Segment } from "semantic-ui-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-enterprise";
import { LicenseManager } from "ag-grid-enterprise";
import LoadingPlaceholder from "../placeholderComponent/loadingPlaceholder";
import CustomNoRowsOverlay from "./customNoRowsOverlay.js";
import { translate } from "react-i18next";
import OrdersHeader from "../orderComponent/ordersHeaders";
import {PROMPTS} from '../../utils/validationConstant'
// import LoadingPlaceholder from "../placeholderComponent/loadingPlaceholder";

LicenseManager.setLicenseKey(
  "Elixia_Tech_Solutions_Ltd_MultiApp_1Devs16_March_2019__MTU1MjY5NDQwMDAwMA==c4c29e5702e62789dbdb799433c73545"
);

class OrderAgGridTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modules: AllModules,
      currentStatus: null,
      defaultColDef: {
        flex: 1,
        // minWidth: 100,
        enableValue: true,
        enableRowGroup: true,
        enablePivot: true,
        resizable: true,
        sortable: true,
        statusLoading: false,
        filter: true,
      },
      // cacheBlockSize: 100,
      // maxBlocksInCache: 10,
      sideBar: {
        toolPanels: [
          {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel",
          },
          {
            id: "filters",
            labelDefault: "Filters",
            labelKey: "filters",
            iconKey: "filter",
            toolPanel: "agFiltersToolPanel",
          },
        ],
        defaultToolPanel: "",
      },
      isLoading: true,
      rowData: [],
      searchValue: "",
      // ag grid custom overlay
      frameworkComponents: {
        actionRenderer: ActionButton,
        customNoRowsOverlay: CustomNoRowsOverlay,
        ...props.extracomponents,
      },
      noRowsOverlayComponent: "customNoRowsOverlay",
      noRowsOverlayComponentParams: {
        noRowsMessageFunc: function () {
          return props?.loadingMessage && props?.loadingMessage.length > 0 ? props.loadingMessage : PROMPTS.NO_RECORDS_FOUND;
        },
      },
    };
  }

  componentDidMount() {
    this.setState({ rowData: this.props.rowData });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps?.searchElement && nextProps?.searchElement.length > 0) {
      this.setState({ searchValue: nextProps.searchElement })
    }
    /*  this.setState(
       { rowData: nextProps.rowData },
       () => this.gridApi && this.gridApi.setRowData(this.state.rowData)
     ); */
  }

  componentDidUpdate(prevProps) {
    if (this.props.handleSearchData != prevProps.handleSearchData) {
      this.setState({ searchValue: this.props.handleSearchData });
    }
  }

  handleSearchInput = (e) => {
    this.setState({ searchValue: e.target.value });
  };

  handleChange = (e) => {
    this.setState({ searchValue: e.target.value });
    this.props.handleChange(e.target.value);
  };

  handleStatusChange = (data) => {
    this.setState({ statusLoading: true });
    setTimeout(() => {
      this.setState({ statusLoading: false });
    }, 2000);
    this.props.checkStatus(data);
  };

  handleFilterChange = (data) => {
    this.setState({ statusLoading: true });
    setTimeout(() => {
      this.setState({ statusLoading: false });
    }, 2000);
    this.props.checkFilter(data);
  };

  handleMetaSearch = (data) => {
  
    this.setState({ statusLoading: true });
    setTimeout(() => {
      this.setState({ statusLoading: false });
    }, 2000);
    this.props.handleMetaSearchCall(data);
  };

  exportDataGrid = () => {
    let keys = [];
    this.props.columnDefs.forEach((element) => {
      element.field !== "edit" && keys.push(element.headerName);
    });
    // console.log(keys);
    let param = {
      fileName: this.props.titleBarTitle,
    };
    this.gridApi.exportDataAsExcel(param);
  };

  getParams() {
    return {
      columnGroups: true,
      fileName: this.props.titleBarTitle,
    };
  }

  onBtnExportDataAsExcel = () => {
    var params = this.getParams();
    this.gridApi.exportDataAsExcel(params);
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.setState({
      isLoading: this.props.isLoading,
    });
    this.gridColumnApi = params.columnApi;
    //AutoSize Columns OnGridReady
    var allColumnIds = [];
    this.gridColumnApi.getAllColumns().forEach(function (column) {
      allColumnIds.push(column.colId);
    });
    this.gridColumnApi.autoSizeColumns(allColumnIds);
  };

  onRowDataChanged = () => {
    if (
      this.props.defaultSelectedRows &&
      this.props.defaultSelectedRows.length > 0
    ) {
      this.gridApi.forEachNode((node) => {
        if (
          this.props.defaultSelectedRows.filter(
            (order) => order.vendor_order_id === node.data.vendor_order_id
          )[0]
        ) {
          node.setSelected(true);
        }
      });
    }
  };

  importDataGrid = () => {
    // console.log("import the data grid");
  };

  export = () => {
    this.setState({ isexport: this.props.exportData });
    this.exportDoc();
  };

  exportDoc = () => {
    if (this.state.isexport == true) {
      this.exportDataGrid();
    }
  };

  exporttrueDataGrid = (value) => {
    this.props.externalAPIexcelDownload(value)
  }

  exportDataGrid = () => {
    if (this.props?.externalAPIexcelDownloadClick) {
      this.props.externalAPIexcelDownload()
    } else {
      let keys = [];
      this.props.columnDefs.forEach((element) => {
        element.field !== "edit" && keys.push(element.headerName);
      });
      // console.log(keys);
      let param = {
        fileName: this.props.titleBarTitle,
      };
      this.gridApi.exportDataAsExcel(param);

    }
  };

  filterChanged = (e) => {
    if (this.gridApi.getDisplayedRowCount() === 0) {
      this.gridApi.showNoRowsOverlay();
    } else {
      this.gridApi.hideOverlay();
    }
  };

  autoSizeAll = (skipHeader) => {
    var allColumnIds = [];
    this.gridColumnApi.getAllColumns().forEach(function (column) {
      allColumnIds.push(column.colId);
    });
    this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
  };

  render() {
    const { frameworkComponents } = this.state;
    const { t } = this.props;

    return (
      <>
        {this.props.showFilter != null &&
          this.props.showFilter != undefined &&
          this.props.showFilter == false ? null : (
          <OrdersHeader
            hideTransporter={this.props.hideTransporter}
            hideVehicleNumber={this.props.hideVehicleNumber}
            hideRequired={this.props.hideRequired}
            showStatusFilter={this.props.showStatusFilter}
            showOrderFilterTop={this.props.showOrderFilterTop}
            showSearchFalse={this.props.showSearchFalse}
            hideNew={this.props?.hideNew ? this.props.hideNew : false}
            isLoading={this.props.isLoading}
            title={this.props.title}
            LinkName="/add-shipment"
            handleSearch={this.handleChange}
            hideFilter={this.props.hideFilter}
            hideImport={this.props.hideImport}
            // importDataGrid={this.importDataGrid}
            from={this.props.from}
            handleStatusChange={this.handleStatusChange}
            handleFilterChange={this.handleFilterChange}
            handleMetaSearch={this.handleMetaSearch}
            exportDataGrid={this.exportDataGrid}
            exporttrueDataGrid={this.exporttrueDataGrid}
            exportHidden={this.props.exportHidden}
            radioToggle={this.props.radioToggle}
            toggleView={this.props.toggleView}
            toggle={this.props.toggle}
            baseURL={this.props.baseURL}
            allotedOrdersStatusShow={this.props.allotedOrdersStatusShow}
            responseReceived={this.props.responseReceived}
            dataPresent={this.props.rowData.length > 0 ? true : false}
            allotedOrder={this.props.allotedOrder||false}
            reportingStatusShow={this.props.reportingStatusShow || false}
            redirectToOrderReports={this.props.redirectToOrderReports}
            searchLoading={this.props.searchLoading}
          />
        )}

        {this.state.statusLoading == true ? (
          <LoadingPlaceholder />
        ) : (
          <>
            <div className="ag-theme-material agOver">
              <AgGridReact
                domLayout="autoHeight"
                modules={this.state.modules}
                sideBar={this.state.sideBar}
                rowGroupPanelShow={"always"}
                quickFilterText={this.state.searchValue}
                suppressAutoSize={true}
                columnDefs={this.props.columnDefs}
                defaultColDef={this.state.defaultColDef}
                frameworkComponents={frameworkComponents}
                loadingCellRenderer={this.state.loadingCellRenderer}
                loadingCellRendererParams={this.state.loadingCellRendererParams}
                rowSelection="multiple"
                rowData={this.props.rowData}
                pinnedBottomRowData={this.props.pinnedBottomRowData}
                exportDataGrid={this.exportDataGrid}
                // checkStatus={this.props.checkStatus(this.state.currentStatus)}
                pagination={true}
                noRowsOverlayComponent={this.state.noRowsOverlayComponent}
                onRowSelected={this.props.rowSelected}
                paginationPageSize={this.props.pegination || 10}
                onGridReady={this.onGridReady}
                baseURL={this.props.baseURL}
                cacheBlockSize={this.state.cacheBlockSize}
                maxBlocksInCache={this.state.maxBlocksInCache}
                completeURL={this.props.completeURL}
                keyIndex={this.props.keyIndex}
                onCellDoubleClicked={this.props.cellDoubleClicked}
                onEdit={this.props.onEdit}
                onDelete={this.props.onDelete}
                onPaginationChanged={this.props.OnpaginationChangeCallback}
                debounceHorizontalScrollbar={true}
                // noRowsOverlayComponent={() => this.state.noRowsOverlayComponent()}
                noRowsOverlayComponentParams={
                  this.state.noRowsOverlayComponentParams
                }
                onFilterChanged={this.filterChanged}
                hideRowEdit={this.props.hideRowEdit}
                {...this.props}
                onRowDataChanged={this.onRowDataChanged}
                responseReceived={this.props.responseReceived}
                exporttrueDataGrid={this.exportDataGrid}


              />
            </div>
          </>
        )}
      </>
    );
    //   }
  }
}

export default translate("ag_grid")(OrderAgGridTable);
